import Client from '../AxiosClient';
const resource = '/private/ioffice';

export default {
    async getSendDocuments(fromDate, toDate) {
        try {
            const response = await Client.get(`${resource}/sentdocuments?from_date=${fromDate}&to_date=${toDate}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

    async getReceiveDocuments(fromDate, toDate) {
        try {
            const response = await Client.get(`${resource}/receivedocuments?from_date=${fromDate}&to_date=${toDate}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getCalendarByDay(day) {
        try {
            const response = await Client.get(`${resource}/calendarbyday?day=${day}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getCalendar(fromDate, toDate) {
        try {
            const response = await Client.get(`${resource}/calendarfromto?from_date=${fromDate}&to_date=${toDate}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getInvitationLetter(fromDate, toDate) {
        try {
            const response = await Client.get(`${resource}/inviteletters?from_date=${fromDate}&to_date=${toDate}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getInvitationLetter_V2(fromDate, toDate, type) {
        try {
            const response = await Client.get(`${resource}/inviteletters_v2?from_date=${fromDate}&to_date=${toDate}&type=${type}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async reportInvitationLetter(fromDate, toDate, type) {
        try {
            const response = await Client.get(`${resource}/inviteletters_report?from_date=${fromDate}&to_date=${toDate}&type=${type}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getProcessDocument(id) {
        try {
            const response = await Client.get(`${resource}/processed_document?id=${id}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async downloadFile(fileName) {
        try {
            const response = await Client.get(`${resource}/inviteletters/file?file_name=${fileName}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async sendSms(phone_list, content) {
        try {
            const response = await Client.get(`${resource}/sendsms?phone_list=${phone_list}&content=${content}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },

    async getMeetingStatistics(username, from, to) {
        try {
            const response = await Client.get(`${resource}/statistics_meeting?username=${username}&from=${from}&to=${to}`)
            //console.log(response.data)
            return response.data;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error
            }
        }
    },
    /**
     * Gửi chỉ đạo nhanh
     */
    async quickGuidance(data) {
        try {
            const response = await Client.post(`${resource}/quick-guidance`, data);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getReportJobUBND(maphong, loaigiaoviec, vaitro, tungay, denngay, sohieu, trichyeu) {
        try {
            const response = await Client.get(`${resource}/report_job_ubnd?maphong=${maphong}&loaigiaoviec=${loaigiaoviec}&vaitro=${vaitro}&tungay=${tungay}&denngay=${denngay}&sohieu=${sohieu}&trichyeu=${trichyeu}`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
    async getDepartment() {
        try {
            const response = await Client.get(`${resource}/department`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },


}